document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('#blog-posts-container');
    const loader = document.querySelector('#blog-loader');
    const filterBtns = document.querySelectorAll('.filter-btn');
    const catSelect = document.querySelector('#blog-cat-select');
    let nextLink = document.querySelector('#blog-pagination a');
    let isFetching = false;

    if (!container || !loader) return;

    // --- Intersection Observer dla animacji kart ---
    const postObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    postObserver.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.1 },
    );

    const initObserve = (elements) => {
        elements.forEach((el) => postObserver.observe(el));
    };

    // --- Funkcja sprawdzająca czy loader jest widoczny (naprawa dla małej ilości postów) ---
    const checkIfNeedMore = () => {
        if (!nextLink || isFetching) return;

        const rect = loader.getBoundingClientRect();
        // Jeśli góra loadera jest wyżej niż dół okna + 100px zapasu
        if (rect.top <= window.innerHeight + 100) {
            loadPosts(nextLink.href, true);
        }
    };

    // --- Intersection Observer dla Infinite Scroll ---
    const loadMoreObserver = new IntersectionObserver(
        async (entries) => {
            if (entries[0].isIntersecting && nextLink && !isFetching) {
                loadPosts(nextLink.href, true);
            }
        },
        { rootMargin: '200px' }, // Zwiększony margines dla lepszej płynności
    );

    loadMoreObserver.observe(loader);

    // --- GŁÓWNA FUNKCJA ŁADOWANIA (AJAX) ---
    async function loadPosts(url, append = false) {
        if (isFetching) return;
        isFetching = true;
        loader.classList.add('is-active');
        loader.style.display = 'flex';

        try {
            const response = await fetch(url);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newPosts = doc.querySelectorAll(
                '#blog-posts-container .post-card',
            );
            const newNextLink = doc.querySelector('#blog-pagination a');

            if (!append) {
                container.innerHTML = '';
                // Przewijanie tylko przy zmianie kategorii, nie przy infinite scroll
                window.scrollTo({
                    top: container.offsetTop - 150,
                    behavior: 'smooth',
                });
            }

            if (newPosts.length > 0) {
                newPosts.forEach((post, index) => {
                    post.classList.remove('is-visible');
                    // Resetujemy delay dla nowych postów
                    post.style.setProperty('--d', `${index * 0.1}s`);
                    container.appendChild(post);
                    postObserver.observe(post);
                });
            }

            // Aktualizacja stanu paginacji
            if (newNextLink) {
                nextLink = newNextLink;
                loader.style.display = 'flex';
            } else {
                nextLink = null;
                loader.style.display = 'none';
            }

            isFetching = false;
            loader.classList.remove('is-active');

            // KLUCZOWE: Po dodaniu postów sprawdź, czy ekran jest już pełny
            // Jeśli nie (np. nadal widać loader), załaduj kolejną paczkę
            setTimeout(checkIfNeedMore, 300);
        } catch (error) {
            console.error('Błąd ładowania:', error);
            loader.classList.remove('is-active');
            isFetching = false;
        }
    }

    // Inicjalizacja dla postów obecnych na starcie (PHP)
    initObserve(document.querySelectorAll('.post-card'));

    // Sprawdzenie na starcie czy dociągnąć więcej (jeśli 3 to za mało na ekran)
    setTimeout(checkIfNeedMore, 500);

    // --- OBSŁUGA FILTRÓW (DESKTOP) ---
    filterBtns.forEach((btn) => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            if (this.classList.contains('is-active')) return;

            const url = this.href;
            filterBtns.forEach((b) => b.classList.remove('is-active'));
            this.classList.add('is-active');

            if (catSelect) catSelect.value = url;

            history.pushState(null, '', url);
            loadPosts(url, false);
        });
    });

    // --- OBSŁUGA FILTRÓW (MOBILE SELECT) ---
    if (catSelect) {
        catSelect.addEventListener('change', function () {
            const url = this.value;
            filterBtns.forEach((b) => {
                b.classList.toggle('is-active', b.href === url);
            });

            history.pushState(null, '', url);
            loadPosts(url, false);
        });
    }

    window.addEventListener('popstate', () => {
        location.reload();
    });
});
